function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance"); }

function _iterableToArrayLimit(arr, i) { if (!(Symbol.iterator in Object(arr) || Object.prototype.toString.call(arr) === "[object Arguments]")) { return; } var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

import React, { useState } from 'react';
import { PropTypes } from 'prop-types';
import './eltabs.scss';

const ElTabs = ({
  onChange,
  titles,
  children
}) => {
  const _useState = useState(0),
        _useState2 = _slicedToArray(_useState, 2),
        selected = _useState2[0],
        changeSelection = _useState2[1];

  const selectionChange = item => {
    if (onChange) {
      onChange(item);
    }

    changeSelection(item);
  };

  return React.createElement("div", {
    className: "tabsContainer"
  }, React.createElement("section", {
    className: "titles"
  }, titles.map((title, index) => React.createElement("div", {
    key: String(title),
    onClick: () => selectionChange(index),
    className: index === selected ? 'title current' : 'title'
  }, title))), React.createElement("div", {
    className: "content"
  }, children[selected]));
};

ElTabs.propTypes = {
  titles: PropTypes.arrayOf(PropTypes.string).isRequired,
  children: PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.node), PropTypes.node]).isRequired,
  onChange: PropTypes.func
};
export default ElTabs;